import React from 'react'
import { NavLink } from "react-router-dom"

/**
  * @class Menu
*/
class Menu extends React.Component {

  /**
   * @class Menu
   * @method closeMenu
   * Scroll on top and close menu from parent
   */
  closeMenu = (e) => {
    window.scrollTo(0,0)
    const callback = this.props.closeMenu || null;
    if (callback) {
      this.props.closeMenu();
    }
  }

  render() {
    return (
      <ul>
        <li><NavLink activeClassName="selected" exact onClick={this.closeMenu} to={"/"}>Home</NavLink></li>
        <li><NavLink activeClassName="selected" exact onClick={this.closeMenu} to={"/agence"}>Agence</NavLink></li>
        <li><NavLink activeClassName="selected" exact onClick={this.closeMenu} to={"/work"}>Work</NavLink></li>
        <li><NavLink activeClassName="selected" exact onClick={this.closeMenu} to={"/contact"}>Contact</NavLink></li>
      </ul>
    )
  }
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Header/Menu.jsx